import App, { DispatchFromProps, StateFromProps } from './App';
import { Store, connect } from './rootReducer';
import {
  attemptGetMessages,
  attemptGetSettings,
  attemptGetShiftDefs,
  attemptGetUserSettings,
  attemptGetVersion,
  atteptGetUnreadMessagesCount,
  changeDate,
  closeModal,
  getHolidays,
  hideErrorModal,
  queueToast,
  setHasInternet,
  setLocationForTracking,
  setShowingRuleViolationInfo,
  toggleMenu,
  toggleScreenBig,
  toggleScreenSmall,
} from './appActions';
import {
  attemptLoadTeamRoster,
  changePeriod,
  changeTeam,
} from './ListView/ListViewActions';

import { Period } from './util/dates';
import { ThunkDispatch } from './types';
import { logout } from './Login/LoginAction';

const mapStateToProps = (store: Store): StateFromProps => ({
  currentDate: store.appReducer.globalSettings.useDateTime,
  idleLogoutSeconds: store.appReducer.globalSettings.idleLogoutSeconds,
  employeeMap: store.listViewReducer.employeeMap,
  shouldShowMenu: store.appReducer.shouldShowMenu,
  modalLoading: store.appReducer.modalLoading,
  version: store.appReducer.version,
  openModals: store.appReducer.openModals,
  toast: store.appReducer.toast,
  errorModal: store.appReducer.errorModal,
  showingRuleViolationInfo: store.appReducer.showingRuleViolationInfo,
  showingDialog:
    store.appReducer.confirmDialog.shown ||
    store.appReducer.errorModal.shown ||
    store.appReducer.infoDialog.shown,
  teams: store.chooseTeamReducer.teams,
  failedPollingEndpoints: store.appReducer.failedPollingEndpoints,
  unreadMessagesPollingSeconds:
    store.appReducer.settings.unreadMessageCountPollingSeconds,
  teamRosterPollingSeconds: store.appReducer.settings.teamRosterPollingSeconds,
  messagesPollingSeconds: store.appReducer.settings.messagesPollingSeconds,
  hasInternet: store.appReducer.hasInternet,
  connectionError: store.appReducer.connectionError,
  activeScope: store.appReducer.settings.activeScope,
  dayMessageMap: store.appReducer.dayMessageMap,
});

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchFromProps => ({
  changeDate: (date: Date) => {
    const newDate = new Date(date);
    newDate.setHours(2); // Adding some hours to avoid being one day off on account of UTC
    dispatch(changeDate(newDate));
  },
  toggleMenu: () => {
    dispatch(toggleMenu());
  },
  closeModal: () => {
    dispatch(closeModal());
  },
  changePeriod: (period: Period) => {
    dispatch(changePeriod(period));
  },
  toggleScreenSmall: () => {
    dispatch(toggleScreenSmall());
  },
  toggleScreenBig: () => {
    dispatch(toggleScreenBig());
  },
  loadShifts: (teamId, requestPeriod, isPoll) => {
    void dispatch(attemptLoadTeamRoster(teamId, requestPeriod, false, isPoll));
  },
  attemptGetVersion: () => {
    void dispatch(attemptGetVersion());
  },
  attemptGetUserSettings: () => {
    void dispatch(attemptGetUserSettings());
  },
  attemptGetSettings: () => {
    void dispatch(attemptGetSettings());
  },
  checkNewMessages: (personIds, from, to, isPoll) => {
    void dispatch(attemptGetMessages(personIds, from, to, isPoll));
  },
  getHolidayArray: () => {
    void dispatch(getHolidays());
  },
  checkUnreadMessages: (teamIds, from, to, isPoll) => {
    void dispatch(atteptGetUnreadMessagesCount(teamIds, from, to, isPoll));
  },
  hideErrorModal: () => dispatch(hideErrorModal()),
  queueToast: (text) => dispatch(queueToast({ text })),
  setLocationForTracking: (location) =>
    dispatch(setLocationForTracking(location)),
  setCurrentTeam(teamId) {
    dispatch(changeTeam(teamId));
  },
  setShowingRuleViolationInfo: (show) => {
    dispatch(setShowingRuleViolationInfo(show));
  },
  getShiftDefinitions: (teamId, period) => {
    void dispatch(attemptGetShiftDefs(teamId, period));
  },
  logout: () => {
    void dispatch(logout());
  },
  setHasInternet: (hasInternet) => {
    dispatch(setHasInternet(hasInternet));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

